//活动开红包 //活动二维码 //股市行情
<template>
    <div class="DescWrapper cardWidth shadowRadius cardPadding cardMinHeight">
        <div v-if="type==='activity'" @click.once="openAnimation" class="activity">
            <img ref="animation" :class="[isOpen ? '' : 'hongbao']" :src="require(`../../assets/img/hongbao/${imgIndex}.png`)" alt="">
        </div>

        <div v-else-if="type==='QRcode'">
            <div class="QRcode" ref="QRcode" @touchstart="longPress" @click="handleClick">
                <img :src="list.QRcode" alt="二维码" id="QRcode">
            </div>
            <div v-if="isApp && this.device === 'android'" class="text">点击二维码并保存图片</div>
            <div class="text" v-else>长按保存后识别</div>
            <div class="useTime">
                <span>二维码有效期:</span>
                <div class="time">
                    {{formatStartData(list.startTime)}}~{{formatStartData(list.endTime)}}
                </div>
            </div>
        </div>

        <div v-else-if="type==='carLimit'">
            <div class="carTitle">
                {{tips}}
            </div>
            <div class="carCardList">
                <div v-for="(item, index) in list.carId" :key="`car-card-${index}`" class="carCard">
                    <img src="~@/assets/img/carCard.png" alt="">
                    <div class="number">{{item}}</div>
                </div>
            </div>
            <div class="carContent">
                {{list.content}}
            </div>
        </div>

        <div v-else-if="type==='stock'">
            <div class="stockTitle">
                <img class="titlePic" src="~@/assets/img/stockTitle.png" alt="">
                <div class="date">{{list[0].date.split(' ')[0].replace(/-/g,'.')}}</div>
            </div>
            <div class="stockInfo">
                <div class="item" :style="{backgroundColor: list[0].type === 'increment'?'rgb(236, 90, 92)':'rgb(90, 189, 130)'}">
                    <div class="name">{{list[0].title}}</div>
                    <div class="count">{{list[0].count}}</div>
                    <div>
                        <img v-if="list[0].type === 'increment'" src="~@/assets/img/goUp.png" alt="">
                        <img v-else src="~@/assets/img/goDown.png" alt="">
                    </div>
                    <div class="percent">{{list[0].type === 'increment'? '+' : ''}}{{list[0].number}} [{{list[0].type === 'increment'? '+' : ''}}{{list[0].percent}}]</div>
                </div>
                <div class="other">
                    <div class="item2" :style="{backgroundColor: list[1].type === 'increment'?'rgb(236, 90, 92)':'rgb(90, 189, 130)'}">
                        <div class="name">{{list[1].title}}</div>
                        <div class="count">{{list[1].count}}</div>
                        <div class="percent">{{list[1].type === 'increment'? '+' : ''}}{{list[1].number}} [{{list[1].type === 'increment'? '+' : ''}}{{list[1].percent}}]</div>
                    </div>
                    <div class="item2" :style="{backgroundColor: list[2].type === 'increment'?'rgb(236, 90, 92)':'rgb(90, 189, 130)'}">
                        <div class="name">{{list[2].title}}</div>
                        <div class="count">{{list[2].count}}</div>
                        <div class="percent">{{list[2].type === 'increment'? '+' : ''}}{{list[2].number}} [{{list[2].type === 'increment'? '+' : ''}}{{list[2].percent}}]</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import html2canvas from 'html2canvas';
    import COVERAPP from "@/utils/COVERAPP";
    import {mapActions, mapState, mapMutations} from 'vuex'
    import {defPreImage, formatDate} from "@/utils/utils";
    export default {
        name: "View23",
        data(){
            return{
                imgIndex: 0,
                isOpen: false,
                timer: null
            }
        },
        props: {
            tips: {
                type: String,
                default: ""
            },
            list: {
                type: Object|Array,
                default: ()=>{}
            },
            type: {
                type: String,
                default: '' //carLimit 车辆限行, QRcode 二维码, activity 开红包, stock 股市行情
            }
        },
        mounted() {

        },
        computed: {
            ...mapState(["isApp", "device"])
        },
        methods: {
            ...mapMutations(["setClearTimer"]),
            ...mapActions(["getActivityList"]),
            openAnimation(){
                this.isOpen = true
                this.setClearTimer(true);
                let i = 0
                this.timer = setInterval(() => {
                    this.imgIndex = i
                    this.imgLoad(this.$refs.animation, ()=>{
                        i++
                        if(i === 54){
                            clearInterval(this.timer)
                            this.getActivityList().then(()=>{})
                        }
                    })
                }, 10)
            },
            imgLoad(img, callback) {
                let timer = setInterval(function() {
                    if (img.complete) {
                        callback(img)
                        clearInterval(timer)
                    }
                }, 10)
             },
            formatStartData(date){
                return formatDate(date, 'yyyy.MM.dd hh:mm:ss')
            },
            formatEndData(date){
                return formatDate(date, 'MM.dd')
            },
            longPress() {
                if(this.isApp && this.device === 'android'){
                    let timeout = 0;
                    timeout = setTimeout(()=>{
                        this.downImg()
                        // this.downloadIamge('QRcode', '图片名称')
                    }, 800)
                    document.addEventListener('touchend', ()=>{
                        clearTimeout(timeout)
                    })
                }
            },
            handleClick(){
                if(this.isApp && this.device === 'android'){
                    COVERAPP.UI.previewImage({
                        current: 0,
                        urls: [this.list.QRcode]
                    })
                }
            },
            downImg() {
                if(!window.plus) return;
                window.plus.gallery.save(this.imgUrl, function () {
                    // alert('保存成功!');
                },function(){
                    // alert('保存失败，请重试!');
                });
            }
        }
    }
</script>

<style scoped lang="less">
    .activity{
        width: 7rem;
        margin: 0 auto;
    }
    .hongbao{
        animation: scale 1.5s linear infinite;
    }
    @keyframes scale {
        0% {transform: scale(1)}
        50% {transform: scale(1.05)}
        100% {transform: scale(1)}
    }
    .QRcode{
        width: 3.49rem;
        height: 3.49rem;
        margin: .24rem auto;
        border: .08rem solid rgb(149,178,249);
        border-radius: .1rem;
        img{
            width: 100%;
            height: 100%;
        }
    }
    .text{
        text-align: center;
        font-size: 0.37rem;
        color: #666666;
        line-height: 0.53rem;
        margin: .04rem 0;
    }

    .useTime{
        text-align: center;
        font-size: 0.37rem;
        color: #666666;
        line-height: 0.53rem;
        margin: .04rem 0;
        display: flex;
        justify-content: center;
        .time{
            text-align: left;
            word-break: break-all;
            width: 4.45rem;
        }
    }

    .carTitle{
        height: .53rem;
        margin: .06rem auto .51rem;
        color: #1d6eff;
        font-weight: 800;
        text-align: center;
        font-size: .53rem;
    }
    .carCardList{
        display: flex;
        justify-content: center;
        align-items: center;
        .carCard{
            width: 2.51rem;
            height: 2.51rem;
            margin: 0 .28rem;
            position: relative;
            .number{
                position: absolute;
                left: 0;
                right: 0;
                top: 0;
                bottom: 0;
                text-align: center;
                line-height: 2.51rem;
                font-size: 1.63rem;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #FFFFFF;
            }
        }
    }
    .carContent{
        margin-top: .45rem;
        font-size: 0.4rem;
        color: #666666;
        line-height: 0.6rem;
        text-align: center;
    }
    .stockTitle{
        padding: 0 .35rem;
        display: flex;
        justify-content: space-between;
        .titlePic{
            width: 1.68rem;
            height: .4rem;
        }
        .date{
            font-family: PingFangSC-Medium, PingFang SC;
            font-size: 0.37rem;
            font-weight: 500;
            color: #666666;
            line-height: 0.37rem;
        }
    }
    .stockInfo{
        display: flex;
        justify-content: space-between;
        width: 7.68rem;
        height: 4.19rem;
        margin: 0.27rem auto 0;
        .item{
            width: 3.65rem;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            align-items: center;
        }
        .other{
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        }
        .item2{
            width: 3.92rem;
            height: 2.05rem;
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            align-items: center;
        }
        .name{
            font-size: 0.35rem;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 0.37rem;
        }
        .count{
            font-size: 0.59rem;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #FFFFFF;
            line-height: 0.53rem;
        }
        .percent{
            font-size: 0.29rem;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 0.29rem;
        }
    }
</style>
